import {useEffect, useState} from 'react';

import {getChangeRequestDueDate} from 'src/openapi/apis/ChangeRequestControllerApi';
import {ChangeRequest} from 'src/openapi/models/ChangeRequest';
import {useAppDispatch} from 'src/store';

export const useDefaultDueDate = (
    changeRequestInfo: ChangeRequest,
    changeRequestUpdateId: number,
): Date | undefined => {
    const dispatch = useAppDispatch();
    const [defaultDueDate, setDefaultDueDate] = useState<Date>();

    useEffect(() => {
        if (changeRequestUpdateId) {
            const changeRequestDueDate = changeRequestInfo?.dueDate;

            if (changeRequestDueDate) {
                setDefaultDueDate(new Date(changeRequestDueDate));
            }

            return;
        }

        const fetchData = async () => {
            const response = await dispatch(getChangeRequestDueDate());

            if (response.payload.success) {
                const dateInfo = response.payload.data;
                setDefaultDueDate(new Date(dateInfo.value));
            }
        };
        fetchData();

    }, [changeRequestUpdateId, changeRequestInfo, dispatch]);

    return defaultDueDate;
};
